<template lang="pug">
.study-result-list
  //- サイドメニュー部
  side-menu.study-result-list__side-menu(
    :userRole='userRole',
    :currentLink='currentLink',
    :linkEvent='sideMenuLinkEvent',
    :logoutEvent='logoutEvent'
  )
    template(#separateText)
      slot(name='sideMenuSeparateText')
    template(#logoutText)
      slot(name='logoutText')
  //- コンテンツ表示部
  .study-result-list__content
    breadcrumb-list.study-result-list__content__breadcrumb(:breadcrumbs='breadcrumbs')
    .study-result-list__content__body
      .study-result-list__content__body__heading
        tab-heading.study-result-list__content__body__heading__tab(:isActive='true')
          slot(name='tabLabel')
      .study-result-list__content__body__main
        .study-result-list__content__body__main__action
          search-study.study-result-list__content__body__main__action__search(
            :yearValue='yearValue',
            :monthValue='monthValue',
            :yearChangeEvent='setYearValue',
            :monthChangeEvent='setMonthValue',
            :yearSelectOptions='yearSelectOptions',
            :monthSelectOptions='monthSelectOptions',
            :searchEvent='searchEvent'
          )
            template(#searchButtonText)
              slot(name='searchButtonText')
        study-result-list-table.study-result-list__content__body__main__table(
          :userRole='userRole',
          :studyLists='studyLists',
          :firstButtonEvent='firstButtonEvent',
          :secondButtonEvent='secondButtonEvent',
          :thirdButtonEvent='thirdButtonEvent'
        )
          template(#titleHeader)
            slot(name='titleHeader')
          template(#subheadYearLabel)
            slot(name='subheadYearLabel')
          template(#subheadMonthLabel)
            slot(name='subheadMonthLabel')
          template(#titleLabel)
            slot(name='titleLabel')
          template(#firstButtonLabel)
            slot(name='firstButtonLabel')
          template(#secondButtonLabel)
            slot(name='secondButtonLabel')
          template(#thirdButtonLabel)
            slot(name='thirdButtonLabel')
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import SideMenu from '@/components/organisms/manager/SideMenu.vue'
import BreadcrumbList from '@/components/organisms/manager/BreadcrumbList.vue'
import TabHeading from '@/components/molecules/manager/TabHeading.vue'
import SearchStudy from '@/components/organisms/manager/SearchStudy.vue'
import StudyResultListTable from '@/components/organisms/manager/StudyResultListTable.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { StudyListType } from '@/models/studyListModel'
import { InputItem } from '@/models/inputItem'
import { LinkSetting } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'

/**
 * 管理画面・履歴管理トップ画面
 */
@Component({
  components: {
    SideMenu,
    BreadcrumbList,
    TabHeading,
    SearchStudy,
    StudyResultListTable,
  },
})
export default class StudyResultList extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // このページのリンク設定
  @Prop()
  currentLink!: LinkSetting

  // サイドメニューリンク押下時のイベント
  @Prop()
  sideMenuLinkEvent!: Function

  // ログアウトボタン押下時のイベント
  @Prop()
  logoutEvent!: Function

  // パンくず一覧情報
  @Prop()
  breadcrumbs!: breadcrumbType[]

  // 実施年度選択オプション
  @Prop()
  yearSelectOptions!: InputItem[]

  // 実施月選択オプション
  @Prop()
  monthSelectOptions!: InputItem[]

  // 検索ボタン押下時イベント
  @Prop()
  searchEvent!: Function

  // テスト一覧表示情報
  @Prop()
  studyLists!: StudyListType[]

  // 1つ目のボタン押下時イベント
  @Prop()
  firstButtonEvent!: Function

  // 2つ目のボタン押下時イベント
  @Prop()
  secondButtonEvent!: Function

  // 3つ目のボタン押下時イベント
  @Prop()
  thirdButtonEvent!: Function

  // === 選択値を保持する変数群
  // 実施年度
  public yearValue = ''
  // 実施月
  public monthValue = ''

  // 実施年度が変更された際呼び出し元にイベントを送信
  @Watch('yearValue')
  private yearUpdated() {
    this.$emit('yearUpdated')
  }

  // === 選択値をセットする関数群
  // 実施年度をセット
  private setYearValue(value: string) {
    this.yearValue = value
  }
  // 実施月をセット
  private setMonthValue(value: string) {
    this.monthValue = value
  }
}
</script>

<style lang="stylus" scoped>
.study-result-list
  display flex
  width 100%
  height 100%

  &__content
    width 100%
    height 100%
    display flex
    flex-direction column
    padding 40px
    gap 20px
    overflow-y auto

    &__body
      display flex
      flex-direction column

      &__heading
        display flex
        height 43px

      &__main
        z-index 1
        width 100%
        min-height 500px
        display flex
        flex-direction column
        border-radius 0px 15px 15px 15px
        background var(--color-manager-list__background)
        box-shadow 0px 3px 5px 0px var(--color-manager-list__shadow)

        &__action
          display flex
          justify-content space-between
          align-items center
          padding 12px 20px

          &__search
            padding 7px 5px
</style>
